// Class words for the storm card. There is no Location fact: the position is the marker itself.
import { keyForWords, resolveStormClass } from '../../../utils/gdacs/stormClass.js';

// Cyclones only; null (row hidden) when neither the severity text nor the track gives a class.
export function stormClassLabel({ event, parsed, t }) {
  if (event?.eventType !== 'TC') return null;
  const words = resolveStormClass({ text: event.severityData?.text, parsed, lng: event.lng });
  return words ? t(`map.hazard.stormClass.${keyForWords(words)}`, words) : null;
}
